import script from "./TransactionsHistory.vue?vue&type=script&setup=true&lang=ts"
export * from "./TransactionsHistory.vue?vue&type=script&setup=true&lang=ts"

import "./TransactionsHistory.vue?vue&type=style&index=0&id=0556671d&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0556671d"]])

export default __exports__